export default __webpack_public_path__ + "static/media/gsb.a46821b4.svg";